import React from 'react';
import { formatDate } from 'utils/dateFormater';
interface AuditType {
    version: any;
    versionIndex: number;
    isSelected: boolean;
    handleVersionSelect: (index: number) => void;
}

const ViewHistoryRow: React.FC<AuditType> = ({
  version,
  versionIndex,
  isSelected,
  handleVersionSelect,
}) => {
  return (
    <>
      <div
        className={`view-history-body-frame-row${isSelected ? ' selected' : ''}`}
        style={{ cursor: 'pointer' }}
        onClick={() => handleVersionSelect(versionIndex)}
      >
        <div className='view-history-body-frame-row-date'>
          <div className='view-history-body-frame-row-date-text'>{formatDate(version.date)}</div>
        </div>
        <div className='view-history-body-frame-row-date'>
          <div className='view-history-body-frame-row-date-texts'>
            <div>{version.allTotal}</div>
          </div>
        </div>
        <div className='view-history-body-frame-row-date'>
          <div className='view-history-body-frame-row-date-texts'>
            <div>{version.newTotal}</div>
          </div>
        </div>
        <div className='view-history-body-frame-row-date'>
          <div className='view-history-body-frame-row-date-texts-underline'>
            <div>View</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewHistoryRow;
